import React from "react";
import styled from "styled-components";
import { palette } from "@/styles/palette";
import { fontFamily } from "@/styles/font";

interface FeedbackModalProps {
    onClose: () => void;
    onFeedback: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ onClose, onFeedback }) => {
    return (
        <Container>
            <Modal>
                <ModalHeader>
                    <CloseButton onClick={onClose}>
                        <img src="/icon/close.png" alt="닫기" width={24} height={24} />
                    </CloseButton>
                </ModalHeader>
                <Content>
                    <Title>술모아를 이용해 주셔서 감사합니다!</Title>
                    <Description>
                        더 나은 서비스를 위해
                        <br />
                        여러분의 소중한 의견을 들려주세요.
                    </Description>
                    <FeedbackButton onClick={onFeedback}>서비스 피드백하기</FeedbackButton>
                </Content>
            </Modal>
            <Overlay onClick={onClose} />
        </Container>
    );
};

export default FeedbackModal;

const Container = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }
`;

const Modal = styled.div`
    position: relative;
    width: 100%;
    max-width: 430px;
    background: ${palette.white};
    border-radius: 20px 20px 0 0;
    padding: 0;
    z-index: 1001;
    overflow: hidden;
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 12px 12px 0;
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 16px 24px 24px;
`;

const Title = styled.h2`
    font-family: ${fontFamily.base};
    font-size: 20px;
    font-weight: 700;
    color: ${palette.gray[900]};
    margin-bottom: 12px;
`;

const Description = styled.p`
    font-family: ${fontFamily.base};
    font-size: 16px;
    line-height: 1.5;
    color: ${palette.gray[700]};
    margin-bottom: 24px;
`;

const FeedbackButton = styled.button`
    width: 100%;
    padding: 16px;
    background-color: ${palette.primary};
    color: ${palette.white};
    border: none;
    border-radius: 8px;
    font-family: ${fontFamily.base};
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${palette.primary}ee;
    }
`;
